module.exports = __webpack_public_path__ + "static/img/build.c36ea0ed.png";